module.exports = __webpack_public_path__ + "img/heart_structureFunction.d25a59e6.png";